import * as core from '../../../../../../../core'

export const RESOURCE = {
  payload: {
    alias: 'summit:outcomes-tree-editor',
    content: {
      root: {
        elements: [
          {
            content: {
              row: {
                elements: [
                  {
                    content: {
                      widget: {
                        widget: {
                          alias: 'summit.outcomes-tree-editor',
                        },
                      },
                    },
                    span: 12,
                  },
                ],
              },
            },
            height: 300,
          },
        ],
      },
    },
    description: 'Summit Outcomes Page (Chart)',
    name: 'summit.outcomes.chart',
    variables: [],
  },
  type: core.quiver.Resource.Type.MosaicPage,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.MosaicPage>
